export const BRANDS_MAP = {
    bma: 'Coral',
    vanilla: 'Coral',
    ladbrokes: 'Ladbrokes',
};
